import styled from "styled-components";
import {
  BRAND,
  GRAY_LIGHT,
  TEXT_SECONDARY
} from "@streeteasy/design-system/colors";
import { Caps, SecondarySmall } from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const RecommendedResourcesContainer = styled.div`
  margin: 0 auto;
  max-width: 1404px;
  padding: 0 48px 64px;

  &:nth-child(3) {
    padding-top: 64px;
  }

  @media screen and (max-width: ${smallScreen}px) {
    padding: 0 24px 48px;

    &:nth-child(3) {
      padding-top: 48px;
    }
  }
`;

export const SubTitle = styled(SecondarySmall).attrs({
  as: "h3"
})`
  color: ${TEXT_SECONDARY};
  font-weight: normal;
  padding: 9px 0;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 -12px;
  padding: 3px 0;

  @media screen and (max-width: ${smallScreen}px) {
    align-items: center;
    flex-direction: column;
    margin: 0;
    padding-top: 19px;
  }
`;

export const Card = styled.div`
  margin: 12px;
  max-width: 420px;
  min-height: 270px;
  min-width: 0;
  position: relative;
  width: 100%;

  @media screen and (max-width: ${smallScreen}px) {
    margin-left: 0;
    margin-right: 0;
    max-width: 420px;
  }
`;

export const Content = styled.div`
  padding: 19px 0 0;
`;

export const Link = styled.a`
  bottom: 0;
  font-size: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const CardTitle = styled(Caps).attrs({
  as: "h3"
})`
  color: ${TEXT_SECONDARY};
  margin: 0 0 4px;
`;

export const Image = styled.img`
  border-bottom: 1px solid ${GRAY_LIGHT};
  display: block;
  height: 209px;
  object-fit: cover;
  width: 100%;
`;

export const CardSubTitle = styled(SecondarySmall).attrs({ as: "h4" })`
  color: ${BRAND};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;
